(() => {
'use strict';
const storageKey='21lab_recent_products_v1';
const labZh=document.documentElement.lang.startsWith('zh');
function readRecent(){try{const value=JSON.parse(localStorage.getItem(storageKey)||'[]');return Array.isArray(value)?value.filter(p=>p&&typeof p.url==='string'&&/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?products\//.test(p.url)&&typeof p.title==='string').slice(0,8):[];}catch{return [];}}
const product=document.querySelector('[data-lab-product]');
if(product){try{const entry={url:product.dataset.url,title:product.dataset.title,image:product.dataset.image,price:product.dataset.price};const items=readRecent().filter(p=>p.url!==entry.url);localStorage.setItem(storageKey,JSON.stringify([entry,...items].slice(0,8)));}catch{}}
function initialiseDrawer(){
const drawer=document.querySelector('cart-drawer');const inner=drawer?.querySelector('.drawer__inner');if(!inner||inner.querySelector('.lab-cart-tabs'))return;
const header=inner.querySelector('.drawer__header');const heading=header?.querySelector('.drawer__heading');if(!header||!heading)return;
drawer.classList.add('lab-drawer');inner.prepend(header);heading.hidden=true;const checkoutButton=inner.querySelector('.cart__checkout-button');if(checkoutButton)checkoutButton.textContent=document.documentElement.lang.startsWith('zh')?'前往結帳':'Proceed to checkout';const delivery=inner.querySelector('.tax-note');if(delivery)delivery.textContent=labZh?'稅項及適用優惠於結帳時顯示。順豐運費於送達時收取；香港訂單選購兩件或以上，即享免運。':'Taxes and discounts, where applicable, are shown at checkout. SF Express delivery fees are collected on delivery; Hong Kong orders of 2+ items ship free.';
const tabs=document.createElement('div');tabs.className='lab-cart-tabs';tabs.setAttribute('role','tablist');tabs.setAttribute('aria-label',labZh?'購物車檢視':'Shopping cart views');
const cartTab=document.createElement('button');cartTab.type='button';cartTab.id='LabCartTab';cartTab.textContent=labZh?'購物車':'CART';cartTab.setAttribute('role','tab');cartTab.setAttribute('aria-selected','true');
const recentTab=document.createElement('button');recentTab.type='button';recentTab.id='LabRecentTab';recentTab.textContent=labZh?'最近瀏覽':'RECENTLY VIEWED';recentTab.setAttribute('role','tab');recentTab.setAttribute('aria-selected','false');recentTab.tabIndex=-1;recentTab.setAttribute('aria-controls','LabRecentPanel');tabs.append(cartTab,recentTab);header.prepend(tabs);
const panel=document.createElement('div');panel.id='LabRecentPanel';panel.className='lab-recent-panel';panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby','LabRecentTab');panel.hidden=true;header.after(panel);
function renderRecent(){panel.replaceChildren();const items=readRecent();if(!items.length){const p=document.createElement('p');p.textContent=labZh?'最近瀏覽的單品會顯示於此。':'Your recently viewed pieces will appear here.';panel.append(p);return;}
for(const item of items){const link=document.createElement('a');link.href=(window.Shopify?.routes?.root||'/').replace(/\/?$/, '/')+item.url.replace(/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?products\//,'products/');link.className='lab-recent-item';if(item.image){const image=document.createElement('img');image.src=item.image;image.alt=item.title;image.loading='lazy';link.append(image);}const text=document.createElement('div');const title=document.createElement('p');title.textContent=item.title;const price=document.createElement('span');price.textContent=item.price||'';text.append(title,price);link.append(text);panel.append(link);}}
function selectRecent(recent){inner.classList.toggle('lab-recent-active',recent);panel.hidden=!recent;cartTab.setAttribute('aria-selected',String(!recent));recentTab.setAttribute('aria-selected',String(recent));cartTab.tabIndex=recent?-1:0;recentTab.tabIndex=recent?0:-1;if(recent)renderRecent();}
cartTab.addEventListener('click',()=>selectRecent(false));recentTab.addEventListener('click',()=>selectRecent(true));tabs.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();const recent=recentTab.getAttribute('aria-selected')!=='true';selectRecent(recent);(recent?recentTab:cartTab).focus();}});
}
document.addEventListener('click',event=>{if(event.target instanceof HTMLDialogElement && event.target.classList.contains('lab-size-dialog'))event.target.close();});
initialiseDrawer();const drawer=document.querySelector('cart-drawer');if(drawer)new MutationObserver(initialiseDrawer).observe(drawer,{childList:true,subtree:true});
document.addEventListener('shopify:section:load',initialiseDrawer);

function syncBuyButtons(scope=document){
for(const button of scope.querySelectorAll('[data-lab-buy-now]')){const form=document.getElementById(button.dataset.productForm);const native=form?.querySelector('[name="add"]');const variant=form?.querySelector('[name="id"]');const disabled=button.dataset.buying==='true'||!variant||variant.disabled||!variant.value||!!native?.disabled||native?.getAttribute('aria-disabled')==='true';if(button.disabled!==disabled)button.disabled=disabled;}}
function observePurchaseForms(){for(const info of document.querySelectorAll('product-info')){if(info.dataset.labPurchaseObserved)continue;info.dataset.labPurchaseObserved='true';new MutationObserver(()=>syncBuyButtons(info)).observe(info,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled']});}syncBuyButtons();}
document.addEventListener('click',async event=>{
const button=event.target.closest?.('[data-lab-buy-now]');if(!button||button.disabled)return;event.preventDefault();
const form=document.getElementById(button.dataset.productForm);const variant=form?.querySelector('[name="id"]');const native=form?.querySelector('[name="add"]');if(!form||!variant?.value||variant.disabled||native?.disabled||native?.getAttribute('aria-disabled')==='true')return;if(!form.reportValidity())return;
const component=button.closest('product-form');const label=button.querySelector('[data-lab-buy-label]');const originalLabel=label?.textContent;const wasDisabled=!!native?.disabled;const root=window.Shopify?.routes?.root||'/';const checkoutUrl=(root.endsWith('/')?root:root+'/')+'checkout';let accepted=false;
component?.handleErrorMessage?.();button.dataset.buying='true';button.disabled=true;button.setAttribute('aria-busy','true');if(native)native.disabled=true;if(label)label.textContent=document.documentElement.lang.startsWith('zh')?'正在前往結帳…':'Opening checkout…';
try{const data=new FormData(form);if(!data.has('quantity'))data.set('quantity','1');const response=await fetch((root.endsWith('/')?root:root+'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:data});accepted=response.ok;const result=await response.json();if(!response.ok||result.status)throw new Error(typeof result.description==='string'?result.description:(result.message||'Unable to add this item.'));if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')await publish(PUB_SUB_EVENTS.cartUpdate,{source:'product-form',productVariantId:data.get('id'),cartData:result});window.location.assign(checkoutUrl);
}catch(error){if(accepted){window.location.assign(checkoutUrl);return;}const message=error.message==='Failed to fetch'?(document.documentElement.lang.startsWith('zh')?'連線中斷，請先查看購物車確認商品。':'Connection interrupted. Check your cart before trying again.'):error.message;if(component?.handleErrorMessage)component.handleErrorMessage(message);else{let notice=form.querySelector('.lab-buy-now-error');if(!notice){notice=document.createElement('p');notice.className='lab-buy-now-error';notice.setAttribute('role','alert');button.after(notice);}notice.textContent=message;}delete button.dataset.buying;button.removeAttribute('aria-busy');if(native)native.disabled=wasDisabled;if(label)label.textContent=originalLabel;syncBuyButtons();}
});
observePurchaseForms();document.addEventListener('shopify:section:load',observePurchaseForms);

})();

/* Match the 21Lab signup form to the storefront's editorial presentation. */
(() => {
  const formId = 'app-embed-container-1157209';
  const styleId = 'lab-forms-presentation';
  const zh = document.documentElement.lang.startsWith('zh');
  const css = `
    :host {
      --forms-body-font: normal 400 14px var(--font-body-family, sans-serif);
      --forms-heading-font: normal 400 22px var(--font-heading-family, sans-serif);
    }
    h2, h3, p, input, button {
      font-family: var(--font-body-family, sans-serif) !important;
      font-weight: 400 !important;
    }
    section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] {
      transform: scale(.85) !important;
      transform-origin: center !important;
    }
    [data-testid="form-teaser"] {
      width: 86px !important;
      height: 86px !important;
      min-width: 86px !important;
      border-radius: 50% !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 10px !important;
      background: #9CBFEA !important;
      color: #121212 !important;
      text-align: center !important;
    }
    [data-testid="form-teaser"] h3 {
      max-width: 66px !important;
      white-space: pre-line !important;
      margin: 0 !important;
      color: #121212 !important;
      font: 400 13px/1.25 var(--font-body-family, sans-serif) !important;
    }
    [data-testid="form-teaser"] [aria-label="Close modal"] { display: none !important; }
    @media (min-width: 600px) {
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] {
        width: min(460px, calc(100vw - 40px)) !important;
        max-width: 460px !important;
        min-height: min(590px, calc(100svh - 44px)) !important;
        grid-template-columns: 1fr !important;
        grid-template-rows: 1fr !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] > div:nth-child(-n+2) {
        grid-row: 1 !important;
        grid-column: 1 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] > div:nth-child(2) {
        display: flex !important;
        flex-direction: column !important;
        justify-content: flex-end !important;
        padding: 40px 42px 78px !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [class*="formHeader"] {
        flex: 0 0 auto !important;
        margin: 0 0 24px !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] h2 {
        font-size: 30px !important;
        font-weight: 400 !important;
        letter-spacing: .07em !important;
        margin-bottom: 24px !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [class*="textBody"] p {
        font-size: 18px !important;
        line-height: 1.4 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] form {
        margin-top: 26px !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [data-testid="field-email"],
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [data-testid="btn-form-submit"] {
        border-radius: 0 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [class*="formDisclaimer"] {
        font-size: 11px !important;
        line-height: 1.4 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [class*="formContainerCloseButtonPosition"] {
        top: auto !important;
        bottom: 20px !important;
        left: 0 !important;
        right: 0 !important;
        width: 100% !important;
        display: flex !important;
        justify-content: center !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [aria-label="Close modal"] {
        width: auto !important;
        height: auto !important;
        padding: 7px 14px !important;
        background: transparent !important;
        color: #fff !important;
        border-radius: 0 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [aria-label="Close modal"] svg { display: none !important; }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [aria-label="Close modal"]::after {
        content: '${zh ? '暫時不用' : 'No thanks.'}';
        font: 400 15px/1.4 var(--font-body-family, sans-serif);
      }
    }
    @media (max-width: 599px) {
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] {
        width: calc(100vw - 24px) !important;
        max-width: calc(100vw - 24px) !important;
        min-height: min(600px, calc(100svh - 32px)) !important;
        grid-template-columns: 1fr !important;
        grid-template-rows: 1fr !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] > div:nth-child(-n+2) {
        grid-row: 1 !important;
        grid-column: 1 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] > div:nth-child(2) {
        display: flex !important;
        flex-direction: column !important;
        justify-content: flex-end !important;
        padding: 24px 24px 70px !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [class*="formHeader"] {
        flex: 0 0 auto !important;
        margin: 0 0 18px !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] h2 {
        font-size: 25px !important;
        font-weight: 400 !important;
        letter-spacing: .06em !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [class*="textBody"] p {
        font-size: 16px !important;
        line-height: 1.4 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [data-testid="field-email"],
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [data-testid="btn-form-submit"] {
        border-radius: 0 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [class*="formContainerCloseButtonPosition"] {
        top: auto !important;
        bottom: 16px !important;
        left: 0 !important;
        right: 0 !important;
        width: 100% !important;
        display: flex !important;
        justify-content: center !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [aria-label="Close modal"] {
        width: auto !important;
        height: auto !important;
        padding: 7px 14px !important;
        background: transparent !important;
        color: #fff !important;
        border-radius: 0 !important;
      }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [aria-label="Close modal"] svg { display: none !important; }
      section[role="dialog"][data-sizing="form-wrapper"][aria-label="21Lab.co"] [aria-label="Close modal"]::after {
        content: '${zh ? '暫時不用' : 'No thanks.'}';
        font: 400 15px/1.4 var(--font-body-family, sans-serif);
      }
    }
  `;
  let attempts = 0;
  const timer = window.setInterval(() => {
    const root = document.getElementById(formId)?.shadowRoot;
    if (root && !root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.appendChild(style);
      if (zh) {
        const copy = new Map([
          ['Get 10% off your first purchase & early access to our next collection.', '首單享九折，率先掌握新系列。'],
          ['ACCESS 10% OFF', '領取首單優惠'],
          ['Email', '電郵地址'],
          ['Enter your email address', '輸入電郵地址'],
          ['No thanks.', '暫時不用']
        ]);
        const translateForm = () => {
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
          while (walker.nextNode()) {
            const node = walker.currentNode;
            const original = node.textContent.trim();
            if (copy.has(original)) node.textContent = node.textContent.replace(original, copy.get(original));
          }
          root.querySelector('[data-testid="form-teaser"]')?.setAttribute('aria-label', '首單九折優惠');
          root.querySelector('[data-testid="btn-form-submit"]')?.setAttribute('aria-label', '領取首單優惠');
          const teaser = root.querySelector('[data-testid="form-teaser"] h3');
          if (teaser && teaser.textContent !== '首單\n九折優惠') teaser.textContent = '首單\n九折優惠';
          root.querySelectorAll('input[type="email"]').forEach(input => {
            input.setAttribute('aria-label', '電郵地址');
            if (input.placeholder) input.placeholder = '輸入電郵地址';
          });
        };
        translateForm();
        new MutationObserver(translateForm).observe(root, { childList: true, subtree: true, characterData: true });
      }
      window.clearInterval(timer);
    } else if (++attempts >= 480) {
      window.clearInterval(timer);
    }
  }, 250);
})();

/* Shop the Look: each related product chooses its own variant and uses the existing cart drawer. */
(() => {
  const openers = new WeakMap();
  const translated = document.documentElement.lang.startsWith('zh');
  document.addEventListener('click', async (event) => {
    const opener = event.target.closest?.('[data-lab-look-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.labLookOpen);
      if (!(dialog instanceof HTMLDialogElement) || dialog.open || opener.disabled) return;
      openers.set(dialog, opener);
      delete dialog.dataset.labLookCartOpened;
      const status = dialog.querySelector('.lab-look-status');
      status.hidden = true;
      status.textContent = '';
      dialog.showModal();
      const anchor = opener.getBoundingClientRect();
      const box = dialog.getBoundingClientRect();
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      dialog.style.left = `${Math.max(16, Math.min(desktop ? anchor.left : (window.innerWidth - box.width) / 2, window.innerWidth - box.width - 16))}px`;
      dialog.style.top = `${Math.max(16, Math.min(desktop ? anchor.top - box.height + anchor.height : (window.innerHeight - box.height) / 2, window.innerHeight - box.height - 16))}px`;
      dialog.querySelector('[data-lab-look-variant]:not(:disabled)')?.focus();
      dialog.addEventListener('close', () => {
        if (!dialog.dataset.labLookCartOpened && opener.isConnected) opener.focus();
      }, { once: true });
      return;
    }
    const closer = event.target.closest?.('[data-lab-look-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (!dialog.dataset.labLookBusy) dialog.close();
      return;
    }
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('lab-look-dialog')) {
      const dialog = event.target;
      const box = dialog.getBoundingClientRect();
      if (!dialog.dataset.labLookBusy && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      return;
    }
    const button = event.target.closest?.('[data-lab-look-variant]');
    if (!button || button.disabled || !/^\d+$/.test(button.dataset.labLookVariant)) return;
    const dialog = button.closest('.lab-look-dialog');
    if (!dialog || dialog.dataset.labLookBusy) return;
    event.preventDefault();
    const options = [...dialog.querySelectorAll('[data-lab-look-variant]')].map(option => ({ option, disabled: option.disabled }));
    const status = dialog.querySelector('.lab-look-status');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const rawRoot = window.Shopify?.routes?.root || '/';
    const root = rawRoot.endsWith('/') ? rawRoot : `${rawRoot}/`;
    dialog.dataset.labLookBusy = 'true';
    dialog.setAttribute('aria-busy', 'true');
    options.forEach(({ option }) => { option.disabled = true; });
    status.textContent = translated ? '正在加入購物車…' : 'Adding to your cart…';
    status.hidden = false;
    let accepted = false;
    let failureStatus = 0;
    try {
      const data = new FormData();
      data.set('id', button.dataset.labLookVariant);
      data.set('quantity', '1');
      const sections = cart?.getSectionsToRender?.().map(section => section.section || section.id);
      if (sections?.length) {
        data.set('sections', sections.join(','));
        data.set('sections_url', window.location.pathname);
      }
      cart?.setActiveElement?.(openers.get(dialog) || button);
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data,
      });
      accepted = response.ok;
      const result = await response.json();
      if (!response.ok || result.status) {
        accepted = false;
        failureStatus = response.status;
        throw new Error(typeof result.description === 'string' ? result.description : (result.message || 'Unable to add this size.'));
      }
      dialog.dataset.labLookCartOpened = 'true';
      dialog.close();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lab-shop-the-look', productVariantId: button.dataset.labLookVariant, cartData: result });
      }
      if (cart?.renderContents && result.sections) {
        cart.classList.remove('is-empty');
        cart.renderContents(result);
      } else {
        window.location.assign(`${root}cart`);
      }
    } catch (error) {
      if (accepted) {
        dialog.dataset.labLookCartOpened = 'true';
        dialog.close();
        window.location.assign(`${root}cart`);
        return;
      }
      status.textContent = error.message === 'Failed to fetch'
        ? (translated ? '連線中斷，請先查看購物車確認商品，再重試。' : 'Connection interrupted. Check your cart before trying again.')
        : error.message;
    } finally {
      delete dialog.dataset.labLookBusy;
      dialog.removeAttribute('aria-busy');
      options.forEach(({ option, disabled }) => { option.disabled = disabled || (failureStatus === 422 && option === button); });
    }
  });
  document.addEventListener('cancel', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('lab-look-dialog') && event.target.dataset.labLookBusy) event.preventDefault();
  }, true);
})();

/* Keep the existing tracking widget while presenting one language at a time. */
(() => {
  const page = document.querySelector('[data-lab-page="contact"]');
  if (!page) return;
  const zh = document.documentElement.lang.startsWith('zh');
  page.querySelectorAll('p').forEach(p => {
    const value = p.textContent.trim();
    if ((zh && value.startsWith('Please enter the tracking number.')) || (!zh && value.startsWith('請輸入順豐追蹤號'))) p.remove();
    else if (value.startsWith('請輸入順豐追蹤號')) {
      const walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const n = walker.currentNode;
        if (n.textContent.includes('請輸入順豐追蹤號')) n.textContent = '請輸入順豐追蹤號碼。如未能查詢，請聯絡客服：';
      }
    }
  });
  if (!zh) page.querySelectorAll('button, input[type="submit"]').forEach(button => {
    if (button.textContent.trim() === '查看') button.textContent = 'Track order';
    if (button.value === '查看') button.value = 'Track order';
  });
})();
